import { render, staticRenderFns } from "./org-select.vue?vue&type=template&id=ea6671fa&scoped=true&"
import script from "./org-select.vue?vue&type=script&lang=js&"
export * from "./org-select.vue?vue&type=script&lang=js&"
import style0 from "./org-select.vue?vue&type=style&index=0&id=ea6671fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6671fa",
  null
  
)

export default component.exports